import axios from 'axios'

import useT from '@/i18n/useT'

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const { t } = useT()
    return Promise.reject(
      (error.response && error.response.data) || t('common.somethingWentWrong'),
    )
  },
)

export default axiosInstance
